import { hash, verify } from "argon2-browser"
import { generateCodeVerifier } from "src/auth/pkce"
import { useAuthStore } from "src/stores/authStore"
import { Log } from "src/util/classes/log"

/**
 * Hashes the password.
 *
 * @param { String | Uint8Array } password
 */
export async function hashPassword(password: string | Uint8Array) {
  try {
    return await hash({ pass: password, salt: generateCodeVerifier() })
  } catch (error) {
    Log.error({ message: "Something went wrong.", error })
  }
}

/**
 * Hashes the Unlock Key.
 *
 * @param { String | Uint8Array } key
 */
export async function hashUnlockKey(key: string | Uint8Array) {
  try {
    return await hash({ pass: key, salt: generateCodeVerifier() })
  } catch (error) {
    Log.error({ message: "Something went wrong.", error })
  }
}

/**
 * Checks if the password is the same by comparing it to the
 * stored hash.
 *
 * @param { String } password
 *
 * @return { Boolean }
 */
export async function checkHashedPassword(password: string): Promise<boolean> {
  const authStore = useAuthStore()
  if (!authStore.passHashed) return false
  try {
    await verify({ pass: password, encoded: authStore.passHashed.encoded })
    return true
  } catch {
    return false
  }
}
